



























































































import Vue from 'vue';
import ServiceResponse from '../../../plugins/servicelayer/responseTypes/serviceResponse';

export default Vue.extend({
  auth: true,
  role: ['admin', 'hostadmin'],
  layout: 'layout-hostadmin',
  data: () => ({
    isLoading: false,
    healthError: undefined as any,
    aboutError: undefined as any,
    appAbout: undefined as any,
    appHealth: undefined as any,
    appLogs: undefined as any,
  }),
  computed: {
    isHostAdmin() {
      return this.$auth.isInRole('HostAdmin');
    },
    dateNow() {
      return Vue.$date.now().format('YYYY-MM-DD');
    },
  },
  async mounted() {
    this.loadHealth();
    this.loadAbout();
  },
  methods: {
    async loadHealth() {
      this.isLoading = true;
      try {
        const response = await this.$service.api.core.app.getHealth();
        this.appHealth = response.data;
      } catch (e) {
        const errorResponse = e as ServiceResponse;
        if (errorResponse?.status === 503) {
          this.appHealth = errorResponse?.data;
        } else {
          Vue.$log.error(e);
          this.healthError = e;
        }
      }
      this.isLoading = false;
    },
    async loadAbout() {
      this.isLoading = true;
      try {
        const response = await this.$service.api.core.app.getAbout();
        this.appAbout = response;
      } catch (e) {
        this.aboutError = e;
        Vue.$log.error(e);
      }
      this.isLoading = false;
    },
  },
});
